import React from "react";
import "./style.scss";

const NavbarEmpty = () => {
  return (
    <div className="navbar-container">
      <nav id="navbar">
        <div className="navbar-left"></div>
        <a href="/" className="navbar-center">
          <img
            id="img"
            alt="icon"
            src={require("../../../assets/Mooshir-text.svg").default}
          />
        </a>
        <div className="navbar-right"></div>
      </nav>
    </div>
  );
};

export default NavbarEmpty;
